<template>
  <div class="container my-5" style="max-width: 700px;">
    <h3 class="fw-bold mb-4">Priority Management</h3>

    <!-- Loading -->
    <div v-if="isLoading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status"></div>
      <p class="mt-2">กำลังโหลดข้อมูล...</p>
    </div>

    <!-- Error -->
    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <!-- รายการ Priority -->
    <ul v-if="!isLoading" class="list-group">
      <li
        v-for="(filter, index) in sortedFilters"
        :key="filter.id || index"
        class="list-group-item d-flex justify-content-between align-items-center"
      >
        <div>
          <strong>#{{ index + 1 }} {{ filter.title }}</strong><br />
          <small class="text-muted">priority_slug: {{ filter.priority_slug }}</small>
        </div>

        <div>
          <button
            class="btn btn-outline-secondary btn-sm me-1"
            :disabled="index === 0"
            @click="moveUp(index)"
          >
            <i class="fa fa-arrow-up"></i>
          </button>
          <button
            class="btn btn-outline-secondary btn-sm"
            :disabled="index === filters.length - 1"
            @click="moveDown(index)"
          >
            <i class="fa fa-arrow-down"></i>
          </button>
        </div>
      </li>
    </ul>

    <!-- ปุ่มบันทึก -->
    <div class="text-end mt-4">
      <button class="btn btn-primary" @click="savePriorities">
        บันทึกทั้งหมด
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { computed } from "vue";

const sortedFilters = computed(() =>
  [...filters.value].sort((a, b) => Number(a.priority_slug) - Number(b.priority_slug))
);

const base_url = "/product-filter/list_filter";
const filters = ref([]);
const isLoading = ref(false);
const errorMessage = ref("");

// โหลดข้อมูล filters
async function load() {
  isLoading.value = true;
  errorMessage.value = "";

  try {
    const response = await axios.get(base_url);
    if (response.data?.filters && Array.isArray(response.data.filters)) {
      filters.value = response.data.filters.map((f, i) => ({
        ...f,
        priority_slug: f.priority_slug || (i + 1).toString(),
      }));
    } else {
      filters.value = [];
    }
  } catch (err) {
    console.error("โหลดข้อมูลล้มเหลว", err);
    errorMessage.value = "ไม่สามารถโหลดข้อมูลได้";
  } finally {
    isLoading.value = false;
  }
}

function moveUp(index) {
  if (index === 0) return;

  const current = filters.value[index];
  const prev = filters.value[index - 1];
  const tempSlug = current.priority_slug;
  current.priority_slug = prev.priority_slug;
  prev.priority_slug = tempSlug;
}

function moveDown(index) {
  if (index === filters.value.length - 1) return;

  const current = filters.value[index];
  const next = filters.value[index + 1];

  const tempSlug = current.priority_slug;
  current.priority_slug = next.priority_slug;
  next.priority_slug = tempSlug;
}


function updatePrioritySlugs() {
  filters.value.forEach((f, i) => {
    f.priority_slug = (i + 1).toString();
  });
}

async function savePriorities() {

  const payload = {
    name: "ฟิลเตอร์หลัก",
    active: 1,
    description: "อัปเดตลำดับ priority_slug",
    filters: filters.value.map((f) => ({
      ...f,
      priority_slug: f.priority_slug.toString(), 
    })),
  };


  try {
    const response = await axios.post("/product-filter/list_filter", payload);
    alert("บันทึกข้อมูลสำเร็จ!");
  } catch (error) {
    console.error("❌ บันทึกไม่สำเร็จ:", error);
    alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
  }
}


onMounted(() => load());
</script>

<style scoped>
.list-group-item {
  transition: background-color 0.2s;
}
.list-group-item:hover {
  background-color: #f8f9fa;
}
</style>
